import Vue from 'vue';
import api from '@groovepages/gd-lib/api';

const pagesUrl = () => `${ window.gdEnv.VUE_APP_API_URL }/groovepages`;
const coreUrl = () => `${ window.gdEnv.VUE_APP_API_URL }/groovedigital`;

export default {
  namespaced: true,
  state: {
    application: {},
    domain: {},
    subdomains: []
  },
  getters: {
    subdomains: state => {
      return state.subdomains;
    },
    domain: state => {
      return state.domain;
    },
    application: state => {
      return state.application;
    },
  },
  mutations: {
    setSubdomains(state, { subdomains, domain, application }) {
      state.subdomains = subdomains;
      state.domain = domain;
      state.application = application;
    },
    clearSubdomains(state)
    {
      state.subdomains = [];
      state.domain = null;
      state.application = null;
    },
    addSubdomain(state, { subdomain }) {
      state.subdomains.push(subdomain);
    },
    updateSubdomain(state, { id, subdomain }) {
      const subdomainIndex = state.subdomains.findIndex(el => el.id === id);
      Vue.set(state.subdomains, subdomainIndex, subdomain);
    },
    removeSubdomain(state, { id }) {
      const deletedSubdomain = state.subdomains.map(item => item.id).indexOf(id);
      state.subdomains.splice(deletedSubdomain, 1);
    },
  },
  actions: {
    async getSubdomains({ commit }, {id, application}) {
      const { status, domain, subdomains } = await api.get(`${ coreUrl() }/domains/${ id }/subdomains`);
      if(status === 'success')
      {
        commit('setSubdomains', { subdomains, domain, application });
        return true;
      }
      return false;
    },
    async addSubdomain({ commit, getters }, { data }) {      
      const { status, subdomain } = await api.post(`${ coreUrl() }/domains/${ getters.domain.id }/subdomains`, data);
      commit('addSubdomain', { subdomain });
      return status;
    },
    async updateSubdomain({ commit, getters }, { data }) {
      const { status, subdomain } = await api.api('put', `${ coreUrl() }/domains/${ getters.domain.id }/subdomains/${ data.id }`, data);
      commit('updateSubdomain', { id: data.id, subdomain });
      return status;
    },
    async deleteSubdomain({ commit, getters }, { id }) {
      await api.delete(`${ coreUrl() }/domains/${ getters.domain.id }/subdomains/${ id }`);
      commit('removeSubdomain', { id });
    },
  }
};
